module.exports = __webpack_public_path__ + "static/media/Medidas_2_4_5_6_8.c0b203ba.pdf";